export default __webpack_public_path__ + "static/home-banner-bg-07b0512cc007697ffbd0af915c13b4bd.jpg";